var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "title": "커뮤니티",
            "src": "/images/sub/subvisual-community.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first page-section--last",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v("미디어")];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "board-search-wrap"
  }, [_c('v-row', {
    staticClass: "row--xs",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "sm": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-md-240px",
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "placeholder": "검색어를 입력하세요."
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticStyle: {
      "border-radius": "10px 0 10px 0"
    },
    attrs: {
      "tile": "",
      "color": "grey"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("검색")])], 1)], 1)], 1), _c('v-divider', {
    staticClass: "grey darken-4 mb-30px",
    staticStyle: {
      "border-width": "2px 0 0"
    }
  }), _c('v-row', {
    attrs: {
      "data-aos": "fade"
    }
  }, _vm._l(_vm.boards, function (board, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "4"
      }
    }, [_c('image-board', {
      on: {
        "click": function click($event) {
          return _vm.view(board._id);
        }
      },
      scopedSlots: _vm._u([{
        key: "image",
        fn: function fn() {
          return [_c('v-img', {
            staticClass: "grey lighten-5",
            attrs: {
              "cover": "",
              "width": "100%",
              "aspect-ratio": 1 / 1,
              "src": board.thumb
            }
          })];
        },
        proxy: true
      }, {
        key: "subject",
        fn: function fn() {
          return [_vm._v(" " + _vm._s(board.subject) + " ")];
        },
        proxy: true
      }], null, true)
    }, [_c('v-row', {
      staticClass: "row--xs"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "font-size-14 grey--text text--lighten-1"
    }, [_vm._v(_vm._s(_vm.$dayjs(board.createdAt).format("YYYY-MM-DD")))])])], 1)], 1)], 1);
  }), 1), _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": "5"
    },
    on: {
      "input": function input($event) {
        return _vm.search(true);
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }